import React, { useContext, useState } from "react";
import { Box, TextField, MenuItem } from "@mui/material";
import { Search } from "@mui/icons-material";
import { PatientAssignmentContext } from "../../context/PatientContext/PatientAssignmentContext";
import PatientAssignmentTable from "./AssignmentComp/PatientAssignmentTable";
import { LocationContext } from "../../context/MasterContext/LocationContext";
import { useTranslation } from "react-i18next";

const Assignment = () => {
  const { t } = useTranslation();
  const {
    assignments,
    locationId,
    setLocationId,
    setPage,
    setMemberType, // 👈 Asegúrate que esto esté aquí
    memberType     // 👈 Y también esto
  } = useContext(PatientAssignmentContext);
  
  const {
    locations,
  } = useContext(LocationContext);

  const [search, setSearch] = useState(""); // ← ahora está controlado

  const uniqueLocations = Array.from(
    new Map(assignments.map((p) => [p.locationId, { id: p.locationId, name: p.location }]))
      .values()
  );

  return (
    <Box sx={{ height: "100%", width: "100%", p: 2, bgcolor: "background.paper", borderRadius: 2 }}>
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <TextField
          variant="outlined"
          placeholder={t("PatientAssignment.SearchPatient")}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{ startAdornment: <Search /> }}
        />
        <TextField
          select
          label={t("PatientAssignment.FilterbyLocation")}
          value={locationId !== null ? locationId : ""}
          onChange={(e) => {
            const selectedValue = e.target.value;
            setLocationId(selectedValue === "" ? null : Number(selectedValue));
            setPage(0);
          }}
          sx={{ width: 200 }}
        >
          <MenuItem value="">{t("PatientAssignment.AllLocations")}</MenuItem>
          {locations.map((loc) => (
            <MenuItem key={loc.locationId} value={loc.locationId}>
              {loc.center}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          label={t("PatientAssignment.FilterbyMemberType")}
          value={memberType ?? ""}
          onChange={(e) => {
            const selected = e.target.value;
            setMemberType(selected === "" ? null : selected); // "ACA" | "MED" | null
            setPage(0);
          }}
          sx={{ width: 200 }}
        >
          <MenuItem value="">{t("PatientAssignment.AllMembers")}</MenuItem>
          <MenuItem value="ACA">Health</MenuItem>
          <MenuItem value="MED">Medicare</MenuItem>
        </TextField>

      </Box>

      <PatientAssignmentTable search={search} />
    </Box>
  );
};

export default Assignment;
